import { createReducer, on } from "@ngrx/store";
import {
  ListAdministratorState,
  initialListAdministratorState,
} from "./list-administrator.state";
import {
  DeleteAdministrators,
  DeleteAdministratorsError,
  DeleteAdministratorsSuccess,
  GetAdministratorListTable,
  GetAdministratorListTableError,
  GetAdministratorListTableSuccess,
  GetAdministratorTableLength,
  GetAdministratorTableLengthError,
  GetAdministratorTableLengthSuccess,
  ResetAdministratorCrudProperties,
  ResetAdministratorState,
  ResetAdministratorTable,
  ResetAdministratorTableError,
  ResetAdministratorTableSuccess,
  ResetUpdateAdminAccountStatusProps,
  UpdateAdminAccountStatus,
  UpdateAdminAccountStatusError,
  UpdateAdminAccountStatusSuccess,
  UpdateAdministratorTable,
} from "./list-administrator.actions";

export const ListAdminstratorReducers = createReducer(
  initialListAdministratorState,
  on(ResetAdministratorState, (): ListAdministratorState => {
    return initialListAdministratorState;
  }),
  on(GetAdministratorListTable, (state): ListAdministratorState => {
    return {
      ...state,
      administratorTableLoader: true,
      tableAdministratorError: false,
    };
  }),
  on(
    GetAdministratorListTableSuccess,
    (state, action): ListAdministratorState => {
      return {
        ...state,
        administratorTableLoader: false,
        administratorTableRecords: action.result,
        tableAdministratorError: false,
      };
    }
  ),
  on(
    GetAdministratorListTableError,
    (state, action): ListAdministratorState => {
      return {
        ...state,
        administratorTableLoader: false,
        administratorTableError: action.administratorTableError,
      };
    }
  ),
  on(GetAdministratorTableLength, (state): ListAdministratorState => {
    return {
      ...state,
      administratorTableError: null,
      administratorTableLoader: true
    };
  }),
  on(
    GetAdministratorTableLengthSuccess,
    (state, action): ListAdministratorState => {
      return {
        ...state,
        administratorRecordsLength: action.length,
        administratorTableLoader: false
      };
    }
  ),
  on(
    GetAdministratorTableLengthError,
    (state, action): ListAdministratorState => {
      return {
        ...state,
        administratorTableError: action.error,
        administratorTableLoader: false
      };
    }
  ),
  on(ResetAdministratorTable, (state): ListAdministratorState => {
    return {
      ...state,
      administratorTableLoader: true,
      isInitialLoadFlowReset: false,
    };
  }),
  on(
    ResetAdministratorTableSuccess,
    (state, action): ListAdministratorState => {
      return {
        ...state,
        administratorTableLoader: false,
        isInitialLoadFlowReset: action.isInitialLoad,
      };
    }
  ),
  on(ResetAdministratorTableError, (state, action): ListAdministratorState => {
    return {
      ...state,
      administratorTableLoader: false,
      administratorTableError: action.error,
      isInitialLoadFlowReset: false,
    };
  }),
  on(DeleteAdministrators, (state): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: true,
    }
  }),
  on(DeleteAdministratorsSuccess, (state): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      crudAdministratorError: null,
      deleteIsSuccessful: true
    }
  }),
  on(DeleteAdministratorsError, (state, action): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      crudAdministratorError: action.error,
      deleteIsSuccessful: false
    }
  }),
  on(ResetAdministratorCrudProperties, (state): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      crudAdministratorError: null,
      deleteIsSuccessful: false
    }
  }),
  on(UpdateAdminAccountStatus, (state): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: true,
      administratorTableLoader: true,
      updateAdminAccountStatusLoader: true,
      isAdminAccountStatusUpdateSuccessful: false,
      updateAdminAccountStatusError: null
    }
  }),
  on(UpdateAdminAccountStatusSuccess, (state, action): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      administratorTableLoader: false,
      updateAdminAccountStatusLoader: false,
      isAdminAccountStatusUpdateSuccessful: action.isAdminAccountStatusUpdateSuccessful,
      updateAdminAccountStatusError: null
    }
  }),
  on(UpdateAdminAccountStatusError, (state, action): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      administratorTableLoader: false,
      updateAdminAccountStatusLoader: false,
      isAdminAccountStatusUpdateSuccessful: false,
      updateAdminAccountStatusError: action.error
    }
  }),
  on(ResetUpdateAdminAccountStatusProps, (state): ListAdministratorState => {
    return {
      ...state,
      crudAdministratorLoader: false,
      administratorTableLoader: false,
      updateAdminAccountStatusLoader: false,
      isAdminAccountStatusUpdateSuccessful: false,
      updateAdminAccountStatusError: null
    }
  }),
  on(UpdateAdministratorTable, (state): ListAdministratorState => {
    return {
      ...state,
      administratorTableLoader: true,
      tableAdministratorError: false,
    };
  })
);
